import { IMetricDefinition } from '../../types';

export const CPA: IMetricDefinition = {
  metric: 'PerformanceMetrics\\CPA',
  titleKey: 'ColumnName_CPA',
};

export const PartialConversionCPA: IMetricDefinition = {
  metric: 'PerformanceMetrics\\PartialConversionCPA',
  titleKey: 'ColumnName_CPA',
};

export const Conversions: IMetricDefinition = {
  metric: 'PerformanceMetrics\\Conversions',
  titleKey: 'ColumnName_Conversions',
};

export const ConversionsCredit: IMetricDefinition = {
  metric: 'PerformanceMetrics\\ConversionsCredit',
  titleKey: 'ColumnName_Conversions',
};

export const ConversionRate: IMetricDefinition = {
  metric: 'PerformanceMetrics\\ConversionRate',
  titleKey: 'ColumnName_ConversionRate',
};

export const PartialConversionRate: IMetricDefinition = {
  metric: 'PerformanceMetrics\\PartialConversionRate',
  titleKey: 'ColumnName_ConversionRate',
};

export const AdvertiserReportedRevenue: IMetricDefinition = {
  metric: 'PerformanceMetrics\\AdvertiserReportedRevenue',
  titleKey: 'ColumnName_Revenue',
};

export const RevenueOnAdSpend: IMetricDefinition = {
  metric: 'PerformanceMetrics\\RevenueOnAdSpend',
  titleKey: 'ColumnName_RevenueOnAdSpend',
};
